import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import URL from 'modules/url'
import assets from 'modules/assets'
import * as actions from 'actions'
import * as house from 'modules/house'
import 'styles/House.less'

// generic
import Spinner from 'components/Utils/Spinner'
import TopWrapper from 'components/Utils/TopWrapper'
import Footer from 'components/Utils/Footer'
import LargeQuote from 'components/Utils/LargeQuote'
import Carousel from 'components/Utils/Carousel'
import RowThreeText from 'components/Utils/RowThreeText'
import RowThreeImage from 'components/Utils/RowThreeImage'
import RowFour from 'components/Utils/RowFour'
import AlertMini from 'components/Utils/AlertMini'
import FAQ from 'components/Utils/HouseFAQ'


// specific to camp
import Timeline from 'components/Utils/Timeline'  // change to generic component?
import Archive from './Archive/Archive'
import Sempai2017 from './camps/2017/Sempai2017'


class House extends Component {
  constructor(props) {
    super(props)
    this.state = {
      technologyCollapsed: true,
      musicCollapsed: true,
      tAndSCollapsed: true
    }
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView()

    let { dispatch } = this.props,
        url = URL(this.props)
    dispatch(actions.token.fetchData(url))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  collapseTechnology() {
    const st = this.state.technologyCollapsed
    this.setState({
      technologyCollapsed: !st
    })
  }
  collapseMusic() {
    const st = this.state.musicCollapsed
    this.setState({
      musicCollapsed: !st
    })
  }
  collapseTAndS() {
    const st = this.state.tAndSCollapsed
    this.setState({
      tAndSCollapsed: !st
    })
  }
  render() {
    let intro, values
    let technology, techDirectorHeader, techDirectorInfo, techTestimonial, techProgramOverview, techCollaborators, techTime
    let music, musicDirectorHeader, musicDirectorInfo, musicTestimonial, musicProgramOverview, musicCollaborators, musicTime
    let admissions, tuition, apply, applyButtons, faq, questions, termsAndConditions
    if (this.state && this.state.data) {
      intro = house.intro(this.state.data)
      values = house.values(this.state.data)
      technology = house.technology(this.state.data)
      techDirectorHeader = house.technologyDirectorHeader(this.state.data)
      techDirectorInfo = house.technologyDirectorInfo(this.state.data)
      techTestimonial = house.technologyTestimonial(this.state.data)
      techProgramOverview = house.technologyProgramOverview(this.state.data)
      techCollaborators = house.technologyCollaborators(this.state.data)
      techTime = house.technologyTime(this.state.data)
      music = house.music(this.state.data)
      musicDirectorHeader = house.musicDirectorHeader(this.state.data)
      musicDirectorInfo = house.musicDirectorInfo(this.state.data)
      musicTestimonial = house.musicTestimonial(this.state.data)
      musicProgramOverview = house.musicProgramOverview(this.state.data)
      musicCollaborators = house.musicCollaborators(this.state.data)
      musicTime = house.musicTime(this.state.data)
      admissions = house.admissions(this.state.data)
      tuition = house.tuition(this.state.data)
      apply = house.apply(this.state.data)
      applyButtons = house.applyButtons(this.state.data)
      faq = house.faq(this.state.data)
      questions = house.questions(this.state.data)
      termsAndConditions = house.termsAndConditions(this.state.data)
    }

    if (!this.state || !this.state.data) {
      return <main className='camp'><Spinner /></main>
    } else {
      let scrollApplyIntoView = (this.state.location.hash == '#apply')
      if (scrollApplyIntoView) {
        this.props.router.push(this.state.location.pathname)
      }
      let alertMiniIfNecessary = <AlertMini alertIsMinimized={true} />
      return (
        <main className="page fade-in">
          {alertMiniIfNecessary}
          <div className="group0 parallax__group">
            <div className="layer parallax__layer--deep">
              <img src={assets('images/H_Blob-3.png')} style={{width: '100%', height: 'auto', maxHeight: '100%'}} />
              <img src={assets('images/blobs/06.png')} style={{width: '90%', height: 'auto', marginTop: '-35vh', maxHeight: '100%'}} />
            </div>

            <div className="layer parallax__layer--base">

              <RowThreeText data={intro} />
              <img src={assets('images/house/rendering.png')} style={{width: '100vw', height: 'auto', marginTop: '50px'}}/>
              <RowThreeText data={values} />

              <section className="main-grid center"><ul className="grid group"><h5 style={{paddingBottom: '5px', borderBottom: '1px solid black'}}>Flagship program: Technology</h5></ul></section>
              <RowThreeText data={technology} />

              <section className="main-grid center"><ul className="grid group collapsible" style={{cursor: 'pointer'}} onClick={this.collapseTechnology.bind(this)}>
                <h3 className="sectra-light dotted-border collapse-text" style={{paddingBottom: '5px'}}>Program Details</h3>
                <h3 className="collapse-sign">{this.state.technologyCollapsed ? '+' : '-'}</h3>
              </ul></section>
              <div className={this.state.technologyCollapsed ? 'collapsible-section-on' : 'collapsible-section-off'}>
                <RowThreeText data={techProgramOverview} />
                <RowThreeText data={techTime} />
                <RowThreeImage data={techDirectorHeader} />
                <RowThreeText data={techDirectorInfo} />
                <RowThreeText data={techTestimonial} />
                <RowThreeText data={techCollaborators} />
                <div className="gakko-video" style={{marginTop: '80px'}}>
                  <iframe src="https://www.youtube.com/embed/BqKCEEprxIY" height="100%" frameBorder="0" allowFullScreen></iframe>
                </div>
              </div>

              <section className="main-grid center"><ul className="grid group"><h5 style={{paddingBottom: '5px', borderBottom: '1px solid black'}}>Flagship program: Music</h5></ul></section>
              <RowThreeText data={music} />

              <section className="main-grid center"><ul className="grid group collapsible" style={{cursor: 'pointer'}} onClick={this.collapseMusic.bind(this)}>
                <h3 className="sectra-light dotted-border collapse-text" style={{paddingBottom: '5px'}}>Program Details</h3>
                <h3 className="collapse-sign">{this.state.musicCollapsed ? '+' : '-'}</h3>
              </ul></section>
              <div className={this.state.musicCollapsed ? 'collapsible-section-on' : 'collapsible-section-off'}>
                <RowThreeText data={musicProgramOverview} />
                <RowThreeText data={musicTime} />
                <RowThreeImage data={musicDirectorHeader} />
                <RowThreeText data={musicDirectorInfo} />
                <RowThreeText data={musicTestimonial} />
                <RowThreeText data={musicCollaborators} />
                <div className="gakko-video" style={{marginTop: '90px'}}>
                  <iframe src="https://www.youtube.com/embed/tZ3mf-QnNIM" height="100%" frameBorder="0" allowFullScreen></iframe>
                </div>
              </div>

              <section className="main-grid center"><ul className="grid group"><h5 style={{paddingBottom: '5px', borderBottom: '1px solid black'}}>Admissions</h5></ul></section>
              <RowThreeText data={admissions} />
              <RowThreeText data={tuition} />
              <RowThreeText isScrollIntoView={scrollApplyIntoView} data={apply} />
              <RowThreeText data={applyButtons} />

              <section className="main-grid center"><ul className="grid group collapsible" style={{cursor: 'pointer'}} onClick={this.collapseTAndS.bind(this)}>
                <h3 className="sectra-light dotted-border collapse-text" style={{paddingBottom: '5px'}}>Terms & Conditions</h3>
                <h3 className="collapse-sign">{this.state.tAndSCollapsed ? '+' : '-'}</h3>
              </ul></section>
              <div className={this.state.tAndSCollapsed ? 'collapsible-section-on' : 'collapsible-section-off'}>
                <RowThreeText data={termsAndConditions} />
              </div>

              <img src={assets('images/house/rendering2.png')} style={{width: '100vw', height: 'auto', marginTop: '100px'}}/>

              <FAQ data={faq} />
              <RowThreeText data={questions} />

              <br/>
              <Footer/>
            </div>
          </div>
        </main>
      )
    }
  }
}
House.contextTypes = {
}
House.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    data: state.token.data,
    alertIsMinimized: state.token.alertIsMinimized,
    scrollDirection: state.token.scrollDirection
  }
}

export default connect(mapStateToProps)(House)



// WEBPACK FOOTER //
// ./src/components/House.js